
    import './styles.scoped.css';
    export default {
  "content-enter": "awsui_content-enter_gwq0h_1g8ek_97",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_gwq0h_1g8ek_1",
  "trigger-expanded": "awsui_trigger-expanded_gwq0h_1g8ek_119",
  "icon": "awsui_icon_gwq0h_1g8ek_133",
  "root": "awsui_root_gwq0h_1g8ek_151",
  "expand-button": "awsui_expand-button_gwq0h_1g8ek_167",
  "expanded": "awsui_expanded_gwq0h_1g8ek_174",
  "icon-container": "awsui_icon-container_gwq0h_1g8ek_178",
  "icon-container-container": "awsui_icon-container-container_gwq0h_1g8ek_183",
  "wrapper": "awsui_wrapper_gwq0h_1g8ek_187",
  "wrapper-default": "awsui_wrapper-default_gwq0h_1g8ek_194",
  "wrapper-footer": "awsui_wrapper-footer_gwq0h_1g8ek_194",
  "wrapper-navigation": "awsui_wrapper-navigation_gwq0h_1g8ek_197",
  "wrapper-container": "awsui_wrapper-container_gwq0h_1g8ek_200",
  "header-deprecated": "awsui_header-deprecated_gwq0h_1g8ek_216",
  "wrapper-expanded": "awsui_wrapper-expanded_gwq0h_1g8ek_238",
  "header": "awsui_header_gwq0h_1g8ek_216",
  "header-wrapper": "awsui_header-wrapper_gwq0h_1g8ek_257",
  "header-button": "awsui_header-button_gwq0h_1g8ek_267",
  "header-container-button": "awsui_header-container-button_gwq0h_1g8ek_267",
  "header-container": "awsui_header-container_gwq0h_1g8ek_267",
  "header-navigation": "awsui_header-navigation_gwq0h_1g8ek_299",
  "header-text": "awsui_header-text_gwq0h_1g8ek_331",
  "content": "awsui_content_gwq0h_1g8ek_97",
  "content-default": "awsui_content-default_gwq0h_1g8ek_338",
  "content-footer": "awsui_content-footer_gwq0h_1g8ek_341",
  "content-expanded": "awsui_content-expanded_gwq0h_1g8ek_344",
  "focusable": "awsui_focusable_gwq0h_1g8ek_348",
  "click-target": "awsui_click-target_gwq0h_1g8ek_359"
};
  